// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Subject,
    SubjectFromJSON,
    SubjectToJSON,
} from '../models';

/**
 * no description
 */
export class LibraryApi extends runtime.BaseAPI {

    /**
     * Get the list of subject tags that items can be tagged with.
     */
    async getSubjectTagsRaw(): Promise<runtime.ApiResponse<Array<Subject>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/library/subject_tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubjectFromJSON));
    }

    /**
     * Get the list of subject tags that items can be tagged with.
     */
    async getSubjectTags(): Promise<Array<Subject>> {
        const response = await this.getSubjectTagsRaw();
        return await response.value();
    }

}
